module.exports = __webpack_public_path__ + "img/caja.fa4b4806.svg";